{
  "translation": {
    "aboutMirador": "در بارهٔ پروژه Mirador",
    "aboutThisItem": "در بارهٔ این مورد",
    "addedFromUrl": "(از آدرس اینترنتی ازافه شده)",
    "addManifestUrl": "مکان منبع",
    "addManifestUrlHelp": "آدرس اینترنتی منبع IIIF ",
    "addResource": "منبع را ازافه کن",
    "annotationCanvasLabel_1/1": "مورد: [{{label}}]",
    "annotationCanvasLabel_1/2": "چپ: [{{label}}]",
    "annotationCanvasLabel_2/2": "راست: [{{label}}]",
    "annotations": "حاشیه نویسی ها",
    "attribution": "نسبت دادن",
    "attributionTitle": "حقوق",
    "authenticationFailed": "تصدیق هویت ناموفق بود.",
    "authenticationRequired": "برای دسترسی کامل نیاز به احراز هویت",
    "backToResults": "بازگشت به نتایج",
    "book": "کتاب",
    "bottom": "پایان",
    "cancel": "لغو",
    "canvasIndex": "فهرست راهنما",
    "changeTheme": "تغیر زمینه",
    "clearSearch": "پاک کن",
    "close": "ببند",
    "closeAddResourceForm": "پرسش‌نامه‌ را ببند",
    "closeAddResourceMenu": "فهرست منابع را ببند",
    "closeCompanionWindow": "پانل را ببند",
    "closeWindow": "پنجره را ببند",
    "collapseSection": "بخش \"{{section}}\" را کوچک کنید",
    "collapseSidePanel": "نوار کناری را کوچک کن",
    "collection": "مجموعه",
    "continue": "ادامه",
    "copy": "کپی",
    "currentItem": "مورد فعلی",
    "currentItem_1/1": "مورد فعلی",
    "currentItem_1/2": "چپ",
    "currentItem_2/2": "راست",
    "dark": "زمینه تاریک",
    "digitizedView": "نمای دیجیتالی شده",
    "dismiss": "مرخص کن",
    "displayNoAnnotations": "هیچ کدام را برجسته نکنید",
    "downloadExport": "صدور فضای کاری",
    "downloadExportWorkspace": "صدور فضای کاری",
    "elastic": "کشدار",
    "elasticDescription": "پنجره ها را آزادانه در یک فضای کاری نامحدود حرکت دهید و اندازه کنید. پنجره ها می تواند همپوشانی داشته باشند.",
    "emptyResourceList": "فهرست منابع شما خالی است",
    "error": "خطا",
    "errorDialogConfirm": "OK",
    "errorDialogTitle": "خطایی اتفاق افتاد",
    "exitFullScreen": "خروج از تمام صفحه",
    "expandSection": "بخش \"{{section}}\" را باز کنید",
    "expandSidePanel": "نوار کناری را باز کن",
    "exportCopied": "پیکربندی فضای کاری در کلیپ بورد شما کپی شد",
    "fetchManifest": "اضافه کن",
    "fullScreen": "تمام صفحه",
    "gallery": "آلبوم عکس",
    "hideZoomControls": "کنترل های بزرگنما را مخفی کنید",
    "highlightAllAnnotations": "همه را برجسته کنید",
    "iiif_homepage": "در باره ی این منبع",
    "iiif_manifest": "بیانیه ی IIIF",
    "iiif_related": "مربوط",
    "iiif_renderings": "فرمت های جایگزین",
    "iiif_seeAlso": "همچنین ببینید",
    "import": "وارد كنید",
    "importWorkspace": "فضای کاری را وارد كنید",
    "importWorkspaceHint": "پیکربندی Mirador 4 را برای وارد کردن جای‌گذاری کنید",
    "item": "مورد: {{label}}",
    "itemList": "فهرست موارد",
    "jsError": "جزییات فنی",
    "jsStack": "{{ stack }}",
    "language": "زبان",
    "layer_hide": "لایه را پنهان کنید",
    "layer_move": "لایه را حرکت دهید",
    "layer_opacity": "لایه کدورت",
    "layer_show": "نمایش لایه",
    "layers": "لایه ها",
    "light": "زمینه رشن",
    "links": "پیوندها",
    "listAllOpenWindows": "پرش به پنجره",
    "login": "وارد به سیستم",
    "logout": "خروج از سیستم",
    "manifestError": "منبع اضافه نمیشود :",
    "maximizeWindow": "پنجره را به حداکثر برسانید",
    "minimizeWindow": "پنجره را به حداقل برسانید",
    "mirador": "Mirador",
    "miradorResources": "منابعی Mirador",
    "miradorViewer": "بیننده Mirador",
    "more": "بیشتر...",
    "moreResults": "نتایج بیشتر",
    "mosaic": "موزائیک",
    "mosaicDescription": "جابجایی و اندازه پنجره ها نسبت به یکدیگر، در چارچوب قابل مشاهده.",
    "moveCompanionWindowToBottom": "حرکت به سمت پایین",
    "moveCompanionWindowToRight": "حرکت به سمت راست",
    "multipartCollection": "مجموعه چند قسمتی",
    "nextCanvas": "مورد بعدی",
    "noItemSelected": "هیچ موردی انتخاب نشده است",
    "numItems_one": "{{number}} مورد",
    "numItems_other": "{{number}} موارد",
    "off": "خاموش",
    "openCompanionWindow_annotations": "حاشیه نویسی ها",
    "openCompanionWindow_attribution": "حقوق",
    "openCompanionWindow_canvas": "فهرست راهنما",
    "openCompanionWindow_info": "اطلاعات",
    "openCompanionWindow_layers": "لایه ها",
    "openCompanionWindow_search": "جستجو",
    "openInCompanionWindow": "در پنل جداگانه باز کن",
    "openWindows": "پنجره های باز",
    "pagination": "{{total}} از {{current}}",
    "position": "موقعیت",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "مورد قبلی",
    "related": "مربوط",
    "resource": "منبع",
    "retry": "امتحان دوباره",
    "right": "حقوق",
    "rights": "مجوز",
    "scroll": "پیمایش",
    "searchInputLabel": "عبارات جستجو",
    "searchNextResult": "نتیجه بعدی",
    "searchNoResults": "نتیجه ای پیدا نشد",
    "searchPreviousResult": "نتیجه قبلی",
    "searchResultsRemaining": "{{numLeft}} باقی مانده",
    "searchSubmitAria": "ارسال جستجو",
    "searchTitle": "جستجو",
    "selectWorkspaceMenu": "نوع فضای کار را انتخاب کنید",
    "showCollection": "نمایش مجموعه",
    "showingNumAnnotations_one": "نمایش {{number}} حاشیه نویسی",
    "showingNumAnnotations_other": "نمایش {{number}} حاشیه نویسی",
    "showZoomControls": "نمایش کنترل های بزرگنمایی",
    "sidebarPanelsNavigation": "پانل های ناوبری نوار کناری",
    "single": "واحد",
    "startHere": "از اینجا شروع کنید",
    "suggestSearch": "این سند را برای \"{{ query }}\" جستجوی کنید",
    "tableOfContentsList": "فهرست مطالب",
    "theme": "زمینه",
    "thumbnailList": "فهرست تصاویر بندانگشتی",
    "thumbnailNavigation": "تصاویر بندانگشتی",
    "thumbnails": "تصاویر بندانگشتی",
    "toggleWindowSideBar": "نوار کناری را تغییر دهید",
    "totalCollections_one": "{{count}} مجموعه",
    "totalCollections_other": "{{count}} مجموعات",
    "totalManifests_one": "{{count}} بیانیه",
    "totalManifests_other": "{{count}} بیانیه ها",
    "tryAgain": "دوباره امتحان کنید",
    "untitled": "[بدون عنوان]",
    "view": "مشاهده",
    "viewWorkspaceConfiguration": "مشاهده پیکربندی فضای کاری",
    "welcome": "به Mirador خوش آمدید",
    "window": "پنجره: {{label}}",
    "windowMenu": "نماهای پنجره و نمایش تصاویر کوچک",
    "windowNavigation": "جهت یابی پنجره",
    "windowPluginButtons": "گزینه ها",
    "windowPluginMenu": "گزینه های پنجره",
    "workspace": "فضای کار",
    "workspaceFullScreen": "تمام صفحه",
    "workspaceMenu": "تنظیمات فضای کاری",
    "workspaceNavigation": "جهت یابی فضای کاری",
    "workspaceOptions": "گزینه های فضای کاری",
    "workspaceSelectionTitle": "نوع فضای کاری را انتخاب کنید",
    "zoomIn": "بزرگنمایی",
    "zoomOut": "کوچک نمایی",
    "zoomReset": " تنظیم بزرگنما"
  }
}
